import { render } from "./FileItem.vue?vue&type=template&id=887d1b60&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=887d1b60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887d1b60"],['__file',"src/common/components/FileLoaderBox/FileItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "887d1b60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('887d1b60', __exports__)) {
    api.reload('887d1b60', __exports__)
  }
  
  module.hot.accept("./FileItem.vue?vue&type=template&id=887d1b60&scoped=true", () => {
    api.rerender('887d1b60', render)
  })

}


export default __exports__